import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import img from "../../images/logo.svg";
import {
  fetchCandidateByID,
  fetchCandidateEmailByID,
} from "../../redux-store/candidateSlicer";
import { fetchInterviewRoundbyCandidateIDReqID } from "../../redux-store/interviewRoundSlicer";
import { fetchRequisitionInfoByID } from "../../redux-store/requisitionSlicer";
import candidateService from "../../service-api/candidateService";
import CandidateFeedback from "./CandidateFeedback";
import { ALLOWED_INTERNAl_EMAILS } from "../../constants/constants";

const AuthenticateEmail = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { candidateEmail } = useSelector((state) => state.candidates);
  const [loading, setLoading] = useState({
    verifyEmail: false,
    verifyOtp: false,
    resendOtp: false,
  });
  const [userOtp, setUserOtp] = useState({ value: "", verified: false });
  const [error, setError] = useState(false);
  const [email, setEmail] = useState({ value: "", verified: false });
  const [resendTimer, setResendTimer] = useState(60);
  const [resendDisabled, setResendDisabled] = useState(true);
  // const [otpExpireTimer, setOtpExpireTimer] = useState(60);
  // const [otpExpired, setOtpExpired] = useState(false);

  const inputRefs = useRef([]);

  let correctOtp = "123456"; // Correct OTP
  const otpLength = correctOtp.length; // Number of OTP fields

  const setButtonLoading = (button, value) => {
    setLoading((prev) => ({ ...prev, [button]: value }));
  };

  const onChange = (value) => {
    setUserOtp({ value, verified: false }); // Reset verification on change

    if (value.length !== otpLength) {
      setError({ otp: "Please enter the complete OTP." });
    } else {
      setError(false);
    }
  };

  const verifyOTP = async () => {
    if (userOtp.value.length !== otpLength) {
      setError({ otp: "Please enter the complete OTP." });
      return;
    }

    setButtonLoading("verifyOtp", true);
    try {
      const response = await candidateService.verifyCandidateOTP({
        id: params.c_id,
        email: candidateEmail.itl_emaili,
        otp: userOtp.value,
      });

      if (response && userOtp.value.length === otpLength) {
        setUserOtp({ value: userOtp.value, verified: true });
        setError(false);
      } else {
        setError({ otp: "Incorrect OTP. Please try again." });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setButtonLoading("verifyOtp", false);
    }
  };

  const verifyEmail = async (e) => {
    e.preventDefault();
    setButtonLoading("verifyEmail", true);

    const allowedInternalEmails = ALLOWED_INTERNAl_EMAILS

    const isAllowedEmail =
      email.value === candidateEmail ||
      allowedInternalEmails.includes(email.value.toLowerCase());

    if (isAllowedEmail) {
      const payload = { email: email.value, id: params.c_id };

      try {
        const response = await candidateService.sendCandidateOtp(payload);

        setEmail((prev) => ({ ...prev, verified: true }));
        setError(false);
        // Removed: setOtpExpireTimer(60);
        // Removed: setOtpExpired(false);
      } catch (error) {
        console.error("OTP Sending Failed:", error);
        setError((prev) => ({
          ...prev,
          email: "Failed to send OTP. Please try again.",
        }));
      } finally {
        setLoading(false);
      }
    } else {
      setError((prev) => ({
        ...prev,
        email: "Unknown Email Address.",
      }));
      setButtonLoading("verifyEmail", false);
    }
  };

  useEffect(() => {
    if (userOtp.verified) {
      dispatch(fetchCandidateByID(params.c_id));
      dispatch(fetchRequisitionInfoByID(params.r_id));
      dispatch(
        fetchInterviewRoundbyCandidateIDReqID({
          reqID: params.r_id,
          canID: params.c_id,
        })
      );
    }
  }, [userOtp]);

  useEffect(() => {
    const getTokenAndFetchCandidate = async () => {
      try {
        await candidateService.getCandidateFeedbackToken();
        dispatch(fetchCandidateEmailByID(params.c_id));
      } catch (error) {
        console.error(
          "Error getting token or fetching candidate email:",
          error
        );
      }
    };

    getTokenAndFetchCandidate();
  }, []);

  // Resend OTP UseEffect & Function
  useEffect(() => {
    if (email.verified && resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (resendTimer === 0) {
      setResendDisabled(false);
    }
  }, [resendTimer, email.verified]);

  const resendOTP = async () => {
    setButtonLoading("resendOtp", true);

    try {
      const payload = { email: email.value, id: params.c_id };
      await candidateService.sendCandidateOtp(payload);
      // setOtpExpireTimer(60);
      // setOtpExpired(false);
    } catch (error) {
      toast.error("Failed to resend OTP. Try again.");
      console.error("Resend OTP Error:", error);
    } finally {
      setResendDisabled(true);
      setResendTimer(60);
      setButtonLoading("resendOtp", false);
      toast.success("OTP Resent Successfully!");
    }
  };

  const handleOTPChange = (index, value) => {
    setError((prev) => ({ ...prev, otp: null }));
    if (value.length > 1) return; // Restrict input to single digit

    let otpArray = userOtp.value.split("");
    otpArray[index] = value;

    setUserOtp({ ...userOtp, value: otpArray.join("") });

    // Move focus to the next input field
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !userOtp.value[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }

    // Call verifyEmail when Enter is pressed and 6 digits are filled
    if (e.key === "Enter" && userOtp.value.length === 6) {
      verifyOTP();
    }
  };

  // useEffect(() => {
  //   if (email.verified && otpExpireTimer > 0) {
  //     const interval = setInterval(() => {
  //       setOtpExpireTimer((prev) => prev - 1);
  //     }, 1000);

  //     return () => clearInterval(interval);
  //   } else if (otpExpireTimer === 0) {
  //     setEmail((prev) => ({ ...prev, verified: false }));
  //     setOtpExpired(true);
  //   }
  // }, [otpExpireTimer, email.verified]);

  return (
    <React.Fragment>
      {!userOtp.verified ? (
        <section className="candidate-feedback-email-auth-wrapper">
          <div className="container d-flex h-100">
            <form
              className="w-100 d-flex"
              onSubmit={email.verified ? verifyOTP : verifyEmail}
            >
              <div className="row w-100">
                <div className="col-md-6 m-auto d-flex flex-column align-items-center">
                  <div className="candidate-email-authenticate-wrapper">
                    <img src={img} alt="" className="mb-4" />

                    <div className="sub-heading mb-4">
                      Please enter your email address to verify.
                    </div>

                    <div className="form-group w-100 mb-4">
                      <input
                        disabled={email.verified}
                        type="email"
                        placeholder="e.g. mikeross123@gmail.com"
                        className="form-control w-100 placeholder-light"
                        onChange={(e) =>
                          setEmail((prev) => ({
                            ...prev,
                            value: e.target.value,
                          }))
                        }
                      />

                      {error.email && (
                        <Typography.Text
                          type="danger"
                          className="mb-4 position-absolute"
                        >
                          <CloseCircleOutlined /> {error.email}
                        </Typography.Text>
                      )}

                      {email.verified && (
                        <Typography.Text
                          type="success"
                          className="mb-4 position-absolute"
                        >
                          <CheckCircleOutlined /> Email Verified.
                        </Typography.Text>
                      )}
                    </div>

                    {!email.verified && (
                      <Button
                        type="primary"
                        className="mt-3 m-auto custom-btn"
                        onClick={verifyEmail}
                        disabled={loading.verifyEmail}
                      >
                        Verify Email{" "}
                        {loading.verifyEmail && (
                          <Spinner animation="border" size="sm" />
                        )}
                      </Button>
                    )}
                    {/* </div> */}

                    {email.verified && (
                      <div className="d-flex align-items-center justify-content-center flex-column">
                        <div className="sub-heading mb-3 mt-3">
                          Enter OTP sent on your email address
                        </div>
                        <div className="mb-3">
                          <Row md={6}>
                            {[0, 1, 2, 3, 4, 5].map((item, index) => (
                              <Col>
                                <input
                                  ref={(el) => (inputRefs.current[index] = el)}
                                  type="number"
                                  className={`form-control text-center w-45-h-45 ${error.otp && "border border-danger"
                                    }`}
                                  value={userOtp.value[index] || ""}
                                  onChange={(e) =>
                                    handleOTPChange(index, e.target.value)
                                  }
                                  onKeyDown={(e) => handleKeyDown(index, e)}
                                />
                              </Col>
                            ))}
                          </Row>
                        </div>
                        {error.otp && (
                          <Typography.Text type="danger" className="mb-1">
                            {error.otp}
                          </Typography.Text>
                        )}

                        <div className="text-center">
                          <Button
                            type="link"
                            disabled={resendDisabled || loading.resendOtp}
                            onClick={resendOTP}
                          >
                            {resendDisabled
                              ? `Resend OTP in ${resendTimer}s`
                              : "Resend OTP"}
                            {loading.resendOtp && (
                              <Spinner animation="border" size="sm" />
                            )}
                          </Button>

                          {/* <div
                            className="text-muted"
                            style={{ fontSize: "14px" }}
                          >
                            {otpExpired
                              ? "OTP expired. Please request a new one."
                              : `OTP expires in ${otpExpireTimer}s`}
                          </div> */}
                        </div>

                        <Button
                          type="primary"
                          className="mt-3 custom-btn"
                          onClick={verifyOTP}
                          disabled={
                            userOtp.value.length !== otpLength ||
                            loading.verifyOtp
                          }
                        >
                          Verify OTP{" "}
                          {loading.verifyOtp && (
                            <Spinner animation="border" size="sm" />
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>
      ) : (
        <CandidateFeedback />
      )}
    </React.Fragment>
  );
};

export default AuthenticateEmail;
